import React from 'react';
import axios from 'axios';

import * as Globals from './../Globals';

export default class Simulation extends React.Component {

    constructor(props) {
		super(props);

        this.userID = this.props.userID;
        this.subjectIDs = this.props.subjectIDs;
        this.status = "RUNNING";
        this.questionsInformation = [];
        this.questionIndex = -1;
        this.response = [];

		this.state = {
            alertCheck: false,
            question: undefined
        };
	}


    componentDidMount() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.post(Globals.EL_PATH + 'testsimulation?Authentication=' + cookie, {
            SUBJECTS: this.subjectIDs
        }).then(response  => {
            let questions = response.data.records.questions;
            let answersInformation;
            questions.map(question => {
                answersInformation = [];
                question.answers.map(answer => {
                    answersInformation.push({
                        id: answer.answer_id,
                        text: answer.answer_text
                    });
                    return null;
                });
                this.questionsInformation.push({
                    id: question.question_id,
                    text: question.question_text,
                    imagePath: question.question_img,
                    answers: answersInformation
                });
                return null;
            });
            if (this.questionsInformation.length === 0) {
                this.status = "FINISHED";
                this.forceUpdate();
            } else {
                this.questionIndex = 0;
                let answers = [];
                this.questionsInformation[this.questionIndex].answers.map(answer => {
                    answers.push({
                        text: answer.text,
                        checked: false
                    });
                    return null;
                });
                this.setState({
                    question: {
                        text: this.questionsInformation[this.questionIndex].text,
                        imagePath: this.questionsInformation[this.questionIndex].imagePath,
                        answers: answers
                    }
                });
            }
         //   console.log(this.questionsInformation);
         //   console.log(this.questionsInformation.length)
        }).catch(error => {
            this.props.CheckAuthError(error);
        })
    }

    stillQuestions() {
        return this.questionIndex < (this.questionsInformation.length - 1);

    }

    nextQuestion() {
        let alertCheck = true;
        this.state.question.answers.map( (answer) => {
            if (answer.checked === true)
                alertCheck = false;
            return null;
        });
        if (alertCheck) {
            this.setState({
                alertCheck: alertCheck
            });
        }
        else {
            let responseAnswers = [];
            this.state.question.answers.map((answer, index) => {
                responseAnswers.push({
                    ANSWER_ID: this.questionsInformation[this.questionIndex].answers[index].id,
                    IS_CHECKED: answer.checked
                });
                return null;
            });
            this.response.push({
                QUESTION_ID: this.questionsInformation[this.questionIndex].id,
                ANSWERS: responseAnswers
            });
            if (this.stillQuestions()) {
                this.questionIndex++;
                let answers = [];
                this.questionsInformation[this.questionIndex].answers.map(answer => {
                    answers.push({
                        text: answer.text,
                        checked: false
                    });
                    return null;
                });
                this.setState({
                    question: {
                        text: this.questionsInformation[this.questionIndex].text,
                        imagePath: this.questionsInformation[this.questionIndex].imagePath,
                        answers: answers
                    }
                });
            }
            else
                this.finishTest();
        }
        // console.log(this.questionIndex);
    }

    handleCheckboxChange(index) {
        let question = this.state.question;
        question.answers[index].checked = !question.answers[index].checked;

        if (this.state.alertCheck) {
            this.setState({
                question: question,
                alertCheck: false
            });
        }
        else {
            this.setState({
                question: question
            });
        }
    }

    getQuestion() {
        return (
            <div>
                <h1 className="text-center" style={{marginTop: '40px'}}>Prüfungssimulation</h1>
                <div className="question margin-top-lg">
                    <div className="well">
                        <h4 className="margin-bottom-md text-center">{ this.state.question.text }</h4>
                        { (this.state.question.imagePath !== null) ? <img alt="" src={ Globals.EL_PATH + this.state.question.imagePath }/> : null }
                        {
                            this.state.question.answers.map( (answer, index) => {
                                return (
                                    <div className="checkbox">
                                        <label className="checkbox-label">
                                            <input className="customCheckbox" type="checkbox" checked={ answer.checked } onChange={ () => this.handleCheckboxChange(index) } />
                                            <span className="label-text"><b>{ answer.text }</b></span>
                                        </label>
                                    </div>
                                );
                            })
                        }
                    </div>
                    { (this.state.alertCheck) ? <div className="alert alert-danger text-center"><b>Sie müssen mindestens eine Antwort auswählen</b></div> : null }
                    <button className="btn btn-info center-block margin-top-md" type="button" onClick={ () => this.nextQuestion() }>Nächste Frage</button>
                </div>
            </div>
        );
    }

    saveQuestion() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.put(`${Globals.EL_PATH}testsimulation?Authentication=${cookie}&USER_ID=${this.userID}&COURSE_ID=${this.props.courseID}`, {
            QUESTIONS: this.response
        })
        .catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    finishTest() {
        this.saveQuestion();
        this.status = "FINISHED";
        this.forceUpdate();
    }

    render() {
        if (this.status === "RUNNING") {
            if (this.state.question !== undefined)
                return this.getQuestion();
            else {
                return (
                    <div>
                        <h1 className="text-center">Prüfungssimulation</h1>
                    </div>
                );
            }
        }
        else if (this.status === "FINISHED") {
            return (
                <div>
                    <h1 className="text-center" style={{marginTop: '40px'}}>Prüfungssimulation</h1>
                    <h4 className="text-center padding-top-sm">Sie haben die Prüfungssimulation beendet. Ihre Ergbenisse können Sie unter dem Reiter Kursübersicht einsehen.</h4>
                    <button type="button" className="btn btn-info center-block margin-top-md" onClick={ () => this.props.finishSimulation() }>Weiter</button>
                </div>
            );
        }
    }

}



// WEBPACK FOOTER //
// ./src/user/Simulation.js